import RootState from 'Store/Root';

import { Props } from './Props';

const designYarnLibrariesSelector = (
  state: RootState,
  props: Props
): TrykApi.Yarns.IYarnLibrarySummary[] => {
  const designState = state.designs.itemsByCode[props.designCode];

  if (!designState || !designState.yarnLibraries) {
    return null;
  }

  return designState.yarnLibraries;
};

export default designYarnLibrariesSelector;
